import styled from "styled-components/macro";

export const Container = styled.div`
  padding: 40px;
  background-color: var(--bs-white);
  box-shadow: var(--primary-box-shadow);
  border-radius: 4px;
`;
